@if (inited) {
  <ng-container>
    <input
      type="text"
      nz-input
      placeholder="Search"
      [(ngModel)]="searchValue"
      (ngModelChange)="onSearchChange()"
    />

    <br />

    <cdk-virtual-scroll-viewport [itemSize]="7" [style.height]="'680px'" class="scroll-details">
      @for (
        vendor of displayGallery | sortBy: 'vendorName';
        track vendor;
        let vendorIndex = $index
      ) {
        <div class="vendor-name">
          <app-vendor-icon [vendorCategory]="category"></app-vendor-icon>
          {{ vendor.vendorName }}
          <a (click)="gotoEdit(vendor)">Manage</a>
        </div>
        <div class="batch-gallery mt15">
          <!--COVER-->
          <ng-container
            *ngTemplateOutlet="
              image;
              context: {
                vendor: vendor,
                img: vendor.gallery.coverImage,
                type: 'Cover',
                storage: 'coverImage',
              }
            "
          >
          </ng-container>

          <!--SEAT MAP-->
          <ng-container
            *ngTemplateOutlet="
              image;
              context: {
                vendor: vendor,
                img: vendor.gallery.seatMap,
                type: 'Seat Map',
                storage: 'seatMap',
              }
            "
          >
          </ng-container>

          <!--ADS + OTHERS-->
          @for (img of vendor.gallery.images ?? []; track img; let index = $index) {
            @if ((img.tags?.indexOf('cover-ads') ?? -1) >= 0) {
              <ng-container
                *ngTemplateOutlet="
                  image;
                  context: { vendor: vendor, img: img, type: 'Advertising', storage: 'gallery' }
                "
              >
              </ng-container>
            } @else {
              <ng-container
                *ngTemplateOutlet="
                  image;
                  context: { vendor: vendor, img: img, type: 'Gallery', storage: 'gallery' }
                "
              >
              </ng-container>
            }
          }
        </div>
      }
    </cdk-virtual-scroll-viewport>

    <br />

    <nz-pagination
      [(nzPageIndex)]="pageIndex"
      [nzTotal]="filteredGallery.length"
      [nzPageSize]="pageSize"
      (nzPageIndexChange)="onPageIndexChange($event)"
    >
    </nz-pagination>
  </ng-container>
}

<ng-template #image let-vendor="vendor" let-img="img" let-type="type" let-storage="storage">
  <div class="img" [ngClass]="{ 'not-compatible': img?.realX < $any(dim)[type] }">
    @if (img?.contentId) {
      <ng-container>
        <img
          width="200"
          height="200"
          (load)="onImageLoad($event, vendor, img)"
          appImgFallback
          [src]="img.contentId"
        />
      </ng-container>
    } @else {
      <img width="200" height="200" src="assets/common/notavail.jpg" />
    }
    <div class="tag">
      <span>{{ type }}</span>
      <a
        nz-popconfirm
        nzPopconfirmTitle="Are you sure?"
        [disabled]="!img"
        (nzOnConfirm)="removeMedia(img, vendor, storage)"
        nzPopconfirmPlacement="top"
        nz-button
        nzSize="small"
      >
        <i nz-icon nzType="delete" nzTheme="outline"></i>
      </a>
      <!--            @if (img.config.originSize.x >= img.minUploadWidth) {-->
      <!--              <span>Ready to handle</span>-->
      <!--              <a nz-popconfirm-->
      <!--                 nzPopconfirmTitle="Are you sure?"-->
      <!--                 (nzOnConfirm)="removeFromBatch(index)"-->
      <!--                 nzPopconfirmPlacement="top" nz-button nzSize="small">-->
      <!--                <i nz-icon nzType="delete" nzTheme="outline"></i>-->
      <!--              </a>-->
      <!--            } @else {-->
      <!--              <span>Not Compatible</span>-->
      <!--              <a (click)="removeFromBatch(index)" nzDanger-->
      <!--                 nz-button nzSize="small">-->
      <!--                <i nz-icon nzType="delete" nzTheme="outline"></i>-->
      <!--              </a>-->
      <!--            }-->
    </div>
  </div>
</ng-template>
